// @flow
import type {ListingShape} from '../components/Hit/Hit';
import type {PinnedListing} from '../components/HitCollection/HitCollection';

/*
GTS returns pinned listing as separate listing not included in props.listings array.

buildListingsCollection conditionally returns array of listings:
    - if pinned listing is present returns array of pinned listing and all listings
    - if pinned listing is not present - return only array of listings.
 */
export const mergeListingsCollectionWithPinnedListing = (
    listings: ListingShape[],
    pinnedListingWrapper: ?PinnedListing
): ListingShape[] => {
    const {listing: pinnedListing} = pinnedListingWrapper || {};

    return [].concat(pinnedListing || [], listings);
};
